const TESTS = {
    HA_BOT_PROPERTYDETAILS_WEB_V1: 'HA_BOT_PropertyDetails_Web_v1',
    HA_BOT_PROPERTYDETAILSVALAUNCH_V2: 'HA_BOT_PropertyDetailsVALaunch_v2',
    HA_BOT_Recommendations_V1: 'HA_BOT_Recommendations_V1',
    HA_BOT_WEB_BEDMAPSPRICERULES: 'HA_BOT_Web_BedMapsPriceRules',
    HA_PDP_BIZMETRICS: 'ha_pdp_bizmetrics',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_IDA_LOGIN_TO_SAVE_TRIPBOARD: 'HA_IDA_LOGIN_TO_SAVE_TRIPBOARD',
    HA_IDA_PDP_CARD_TEST: 'HA_IDA_PDP_CARD_TEST',
    HA_IDA_PDP_GOOGLEONETAP: 'HA_IDA_PDP_GOOGLEONETAP',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_INQUIRY_FORM_REDUNDANCIES_REMOVED: 'HA_Inquiry_Form_Redundancies_Removed',
    HA_PDP_PROPERTY_DESCRIPTION_FALLBACK: 'ha_pdp_property_description_fallback',
    HA_PDP_VIRTUAL_TOUR_VIEWER: 'ha_pdp_virtual_tour_viewer',
    HA_VIRTUAL_TOUR_VIEWER_PDP_MOBILE: 'ha_virtual_tour_viewer_pdp_mobile',
    HA_PULSE_COACHMARK_VIEW_BOARD: 'ha_pulse_coachmark_view_board',
    HA_PULSE_TRIPBOARD_NEW_MODAL_TEST: 'ha_pulse_tripboard_new_modal_test',
    HA_PDP_MWEB_PERF_INSIGHTS: 'ha_pdp_mweb_perf_insights',
    HA_REACT_PRICE_DETAILS_: 'HA_REACT_PRICE_DETAILS_.*',
    PCSLPSDATAEXPERIMENT: 'pcsLpsDataExperiment',
    HA_PDP_REVIEWS_ON_DEMAND_TRANSLATION: 'ha_pdp_reviews_on_demand_translation',
    HA_PDP_RANKED_BADGES: 'ha_pdp_ranked_badges',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    REMOVE_PARTNER_NAME_AND_LOGO_FROM_PDP: 'remove_partner_name_and_logo_from_PDP',
    INLINE_PDP_VIRTUAL_TOUR: 'Inline_PDP_Virtual_Tour',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    FAMILY_COLLECTION_BADGE: 'family_collection_badge',
    HA_PDP_RECO_NEW_TAB: 'HA_PDP_RECO_NEW_TAB',
    HA_TOI_PDP_V1: 'ha_toi_pdp_v1',
    HA_AFFIRM_LAUNCH_WEB: 'HA_Affirm_Launch_Web',
    HA_PDP_RECO_CAROUSEL_POSITION: 'HA_PDP_RECO_CAROUSEL_POSITION',
    HA_IDA_PDP_LOGIN_TO_BOOK: 'HA_IDA_PDP_LOGIN_TO_BOOK',
    HA_PTA_LANDING_ADS_ON_PDP: 'HA_PTA_LANDING_R1AdsOnPDP',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PDP_CGS_DESCRIPTION: 'ha_pdp_cgs_description',
    HA_TRAVELER_SAME_DAY_BOOKINGS: 'HA_TRAVELER_SAME_DAY_BOOKINGS',
    HA_TRAVELER_SAME_DAY_THROTTLE: 'HA_TRAVELER_SAME_DAY_THROTTLE',
    HA_PDP_VIRTUAL_TOUR_HELPFULNESS: 'HA_PDP_virtual_tour_helpfulness',
    VRBO_WEB_PDP_PHOTO_GRID: 'vrbo_web_PDP_photo_grid',
    VRBO_RECO_SHARED_COMPONENT: 'vrbo_reco_shared_component',
    VRBO_SERP_PDP_COVID_BANNER: 'vrbo_serp_pdp_covid_banner',
    VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY: 'vrbo_web_simple_right_rail_display',
    VRBO_WEB_PDP_RIGHT_RAIL_FREE_CANCELLATION: 'vrbo_web_pdp_right_rail_free_cancellation',
    VRBO_WEB_PDP_POLICIES_SECTION: 'vrbo_web_pdp_policies_section',
    HA_PTA_SEARCHFORM_PDPDESKTOPTABLETWEB: 'HA_PTA_SEARCHFORM_PDPdesktoptabletweb',
    HA_PTA_SEARCHFORM_PDPMWEB: 'HA_PTA_SEARCHFORM_PDPmweb',
    VRBO_LANDING_PDP_REDIRECT_TO_SLP: 'VRBO_LANDING_PDPRedirectToSLP',
    VRBO_PDP_R2D2_QUERY: 'vrbo_pdp_r2d2_query',
    VRBO_PDP_DISPLAY_TRAVELER_SENTIMENTS: 'vrbo_pdp_display_traveler_sentiments',
    VRBO_PDP_R2D2_PLANB: 'vrbo_pdp_r2d2_planB',
    HA_PTA_LANDING_PDPBACKTOSERPBUTTON: 'HA_PTA_LANDING_PDPBackToSERPButton'
};

const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
